import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'pengajuanAngkaKredit'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const angkaKreditCreate = 'Kepegawaian/PengajuanAngkaKredit/create/'
export const angkaKreditList = 'Kepegawaian/PengajuanAngkaKredit/list/'
export const angkaKreditDetail = 'Kepegawaian/PengajuanAngkaKredit/detail/'
export const angkaKreditUpdate = 'Kepegawaian/PengajuanAngkaKredit/update/'
export const angkaKreditInactive = 'Kepegawaian/PengajuanAngkaKredit/inactive/'
export const angkaKreditActive = 'Kepegawaian/PengajuanAngkaKredit/active/'
export const angkaKreditApprove = 'Kepegawaian/PengajuanAngkaKredit/approve/'
export const employeeList = 'Kepegawaian/PengajuanAngkaKredit/listEmployee/'

export const angkaKreditCheckDate = 'Kepegawaian/PengajuanAngkaKredit/checkDate/'
export const angkaKreditCheckNumber = 'Kepegawaian/PengajuanAngkaKredit/checkNumber/'

export const angkaKreditReport = 'Kepegawaian/PengajuanAngkaKredit/report/'
export const angkaKreditReportSend = 'Kepegawaian/PengajuanAngkaKredit/reportSend/'
export const angkaKreditReportApproval = 'Kepegawaian/PengajuanAngkaKredit/reportApproval/'

export const getMaxDate = 'Kepegawaian/PengajuanAngkaKredit/getMinDate/'

export const angkaKreditTotal = "Kepegawaian/PengajuanAngkaKredit/get_info_credit_number/";

export const checkMonth = "Kepegawaian/PengajuanAngkaKredit/checkMonth/"

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}